<div class="footer-details" [ngClass]="screenClasses()">
  <div class="cover">
    <on-ui-cover [cover]="cover"></on-ui-cover>
  </div>
  <div class="info">
    <div class="subject">{{ subjectName }}</div>
    <div class="title">{{ title }}</div>
    <div class="more-info">
      <ng-template [ngIf]="isSingle" [ngIfThen]="singleRef"></ng-template>
      <ng-template [ngIf]="isRegular" [ngIfThen]="regularRef"></ng-template>
      <ng-template [ngIf]="isCourse" [ngIfThen]="courseRef"></ng-template>
    </div>
  </div>
  <div class="type" *ngIf="typeName">{{ typeName | customLocale }}</div>
</div>

<ng-template #singleRef>
  <ul data-test="single">
    <li>
      {{ firstDate | date : 'dd MMM YYYY' }}
    </li>
    <li>{{ firstDate | date : 'EE' }}</li>
    <li>{{ firstDate | date : 'HH:mm' }}</li>
    <li>{{ userService.duration }} {{ 'library.user-service-card.min' | customLocale }}</li>
  </ul>
</ng-template>

<ng-template #regularRef>
  <ng-container [ngSwitch]="time?.length">
    <ng-container *ngSwitchCase="0">
      <ul data-test="regular0"></ul>
    </ng-container>
    <ng-container *ngSwitchCase="1">
      <ul data-test="regular1">
        <li>{{ 'user-service-checkout-wizard.from' | customLocale }} {{ firstDate | date : 'dd MMM YYYY' }}</li>
        <li>{{ 'user-service-checkout-wizard.every' | customLocale }} {{ firstDate | date : 'EEEE' }}</li>
        <li>{{ firstDate | date : 'HH:mm' }}</li>
        <li>{{ userService.duration }} {{ 'library.user-service-card.min' | customLocale }}</li>
      </ul>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ul data-test="regulatM">
        <li>{{ 'user-service-checkout-wizard.from' | customLocale }} {{ firstDate | date : 'dd MMM YYYY' }}</li>
        <li>
          {{ 'user-service-checkout-wizard.classes-per-week' | customLocale : { times: time.length.toString() } }}
          <span class="full-dates" [appPopover]="regularDatesPopoverRef">{{
            'user-service-checkout-wizard.see-all' | customLocale
          }}</span>
        </li>
      </ul>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #courseRef>
  <ul data-test="course">
    <li *ngIf="firstDate">
      {{ 'user-service-checkout-wizard.from' | customLocale }} {{ firstDate | date : 'dd MMM YYYY' }}
    </li>
    <li>{{ 'teacher-card.stats.classes' | customLocale }} {{ userService?.options?.meetings_limit }}</li>
  </ul>
</ng-template>

<ng-template #regularDatesPopoverRef>
  <div class="course-popover">
    <div class="date-item" *ngFor="let event of time; trackBy: trackByFn">
      {{ 'user-service-checkout-wizard.every' | customLocale }} {{ event | date : 'EEEE' }}
      {{ 'user-service-checkout-wizard.in' | customLocale }} {{ event | date : 'HH:mm' }} ({{ userService.duration }}
      {{ 'library.user-service-card.min' | customLocale }})
    </div>
  </div>
</ng-template>
